// popperConfig para menus "⋮" dentro de tabelas.
// - boundary: [] deixa só a viewport como limite para flip e preventOverflow
//   (senão o Popper limita o menu ao wrapper da tabela, baixo com poucas
//   linhas).
// - onFirstUpdate: na 1ª posição o menu ainda está absoluto dentro do wrapper
//   da tabela e pode gerar rolagem, o que deixa a posição calculada errada
//   (só acertava ao redimensionar a janela). Disparar um resize depois que o
//   menu virou fixed faz o Popper recalcular com o layout final.
export const jdsMenuPopperConfig = {
  strategy: 'fixed',
  modifiers: {
    flip: { options: { boundary: [] } },
    preventOverflow: { options: { boundary: [] } },
  },
  onFirstUpdate: () =>
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))),
};
